module.exports = __webpack_public_path__ + "static/img/03.1f74ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/03.png
// module id = q12W
// module chunks = 1